<template>
    <div class="login-fields-container">
        <div class="field-wrapper">
            <ion-icon class="ionicon-icon" name="mail-outline"></ion-icon>
            <input class="login-field" v-checkenter="login" type="email" v-model="username" :placeholder="placeholder ? placeholder : 'E-mail'">
        </div>
        <div class="field-wrapper" v-if="usePassword">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="login-field" type="password" v-checkenter="login" v-model="password" :placeholder="passwordPlaceholder ? passwordPlaceholder : 'Senha'">
        </div>
        <input class="login-button" type="button" :value="cta ? cta : 'ENTRAR'" @click.prevent="login">
    </div>
</template>

<script>
    import api from '@/services/api';
    import encrypt from '@/services/encrypt';

    export default {
        name: 'EmailLogin',

        props: {
            usePassword: true,
            placeholder: '', 
            passwordPlaceholder: '',
            cta: ''
        },

        data ()
        {
            return {
                username: '',
                password: '',
                processing: false
            }
        },

        methods: {
            async login ()
            {
                this.username = this.username.toLowerCase().trim();
                this.password = this.password.trim();

                if (!this.usePassword) this.password = this.username;

                //console.log('pass', this.password);
                const encPass =  await encrypt(this.password);
                //console.log('encPass', encPass);

                if (this.username && this.password && !this.processing)
                {
                    this.processing = true;
                    api
                        .post(`event/${this.$store.state.eventId}/login`, { email: this.username, password: encPass })
                        .then(response => {
                            this.processing = false;
                            this.$emit('logged', response);
                        })
                        .catch(err => {
                            console.log('catch');
                            if (err.response?.data.error.includes('Valid process expected'))
                            {
                                api
                                    .post(`event/${this.$store.state.eventId}/retryValidMail`, {
                                        email: this.username,
                                    })
                                    .then(response => {
                                        this.processing = false;
                                        this.$emit('error', 'notValidated');
                                    })
                                    .catch(err => {
                                        this.processing = false;
                                        this.$emit('error', 'fail');
                                    });
                            }
                            else
                            {
                                this.processing = false;
                                this.$emit('error', 'fail');
                            }
                        });
                }
                else
                {
                    this.processing = false;
                    // show error
                    this.$emit('error', 'fail');
                }
            }
        }
        
    }
</script>

<style lang="scss">
    
</style>